exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6251ca9f] .el-button--success{background-color:#67c23a!important}", ""]);

// exports
